import createModel from 'utils/model'
import {fissionWelcomeMessage} from '../../service'

export default createModel({
    namespace: 'crm_fissionChannelManage_welcomeMessageModal',

    state: {},

    effects: {
        *edit({payload}, {call}) {
            return yield call(fissionWelcomeMessage, payload)
        },
    },

    reducers: {},
})
